export default {
  'button-label': 'Partager mon code',
  'subject': 'Partagez votre code de parrainage',
  'content':
    "C'est ton jour de chance 🎉\n\nJe suis fan de Mon Marché et j'aimerais partager avec toi cette expérience unique. Profite de mon code promo '%{referralCode}'! 🤩 pour bénéficier de 20€ offerts.\n\nRDV ici : %{referralLink}",
};
